module.exports = __webpack_public_path__ + "b5f147d87332c1726ab93f89fbb88146.svg";